<div class="header ps-5 pe-5">
  <div></div>

  <div class="d-row">
    @if (!loadingTenant) {
      <a class="d-row px-5 menu-header c-blue" (click)="openTenants()" (clickOutside)="showTenants = false">
        <img [src]="'assets/images/' + tenantActive?.flag" width="24" height="24" />
        <span class="subtitle-1 ms-2 me-4">{{ tenantActive?.name }}</span>
        <lib-elux-icon [icon]="showTenants ? 'Chevron_Up.svg' : 'Chevron_Down.svg'" [size]="'24'" />

        @if (showTenants) {
          <div class="dropdown-header d-column p-4 mt-3">
            <a
              class="link-tenant px-3 py-2 mb-1"
              *ngFor="let tenant of tenantsAvaibles; let i = index"
              (click)="changeTenant(tenant)"
            >
              <img [src]="'assets/images/' + tenant.flag" width="24" height="24" />
              <span class="subtitle-1 ms-2">{{ tenant.name }}</span>
            </a>
          </div>
        }
      </a>
    } @else {
      <div class="d-row px-5 menu-header c-blue">
        <lib-elux-loading />
      </div>
    }

    <a class="d-row menu-header btn-profile p-2 c-blue" (click)="openProfile()" (clickOutside)="showProfile = false">
      <div class="div-user">
        <img src="assets/icons/Avatar2.svg" width="24" height="24" />
        <span class="subtitle-1 ms-2 me-4">{{ getUserInfo()?.Name }}</span>
      </div>
      <div>
        <lib-elux-icon [icon]="showProfile ? 'Chevron_Up.svg' : 'Chevron_Down.svg'" [size]="'24'" />
      </div>

      @if (showProfile) {
        <div class="dropdown-header d-column p-4 mt-1">
          <a routerLink="/manage/my-account" class="subtitle-1 link-tenant px-3 py-2 mb-1">Minha conta</a>
          @if (allowManageUsers) {
            <a routerLink="/manage/user-and-profile" class="subtitle-1 link-tenant px-3 py-2 mb-1">
              Gerenciar usuários
            </a>
          }
          <a class="subtitle-1 link-tenant px-3 py-2 mb-1" (click)="logout()">Sair</a>
        </div>
      }
    </a>
  </div>
</div>
